'use client';

import { SeoReviewItem } from '@actr/stores/src/stores/models/seo/review';
import { ThemeColorValueImportance } from '@actr/style/src/specs/theme-v2';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import React, { memo, useState } from 'react';

import ReviewModal from '@/components/reviews/modals/review-modal';
import StarRating from '@/components/reviews/stars-rating';
import { getFormattedDate } from '@/utils/get-formated-date';

import * as Styled from './style.css';

export type ReviewProps = SeoReviewItem & {
  isReviewsPage: boolean;
  isHidden?: boolean;
};

const Review: React.FC<ReviewProps> = ({
  rating,
  user,
  date,
  review,
  answer,
  isReviewsPage,
  isHidden,
}) => {
  const [isOpenReviewModal, setOpenReviewModal] = useState(false);

  function handleOpenReviewModal() {
    setOpenReviewModal(prev => !prev);
  }

  function handleCloseReviewModal() {
    setOpenReviewModal(false);
  }

  return (
    <div
      className={Styled.MainWrapper({
        isHidden: isHidden || false,
        isReviewsPage,
      })}
      itemScope
      itemType="https://schema.org/Review">
      <div itemProp="itemReviewed" itemScope itemType="https://schema.org/Organization" itemID="#Organization">
        <meta itemProp="name" content="Авиакасса" />
        <meta itemProp="telephone" content="+7 (495) 970-17-17" />
        <meta itemProp="address" content="г. Москва, Хорошевское шоссе, 32А" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify([
            {
              '@id': '#Organization',
              url: 'https://www.aviakassa.com',
              aggregateRating:
            { '@type': 'AggregateRating',
              ratingValue: 4.8,
              ratingCount: 1080,
              bestRating: 5,
              ratingExplanation: 'Средний рейтинг: 4.8 из 5 на основе 1080 отзывов' }
            }
          ]) }}
        />
      </div>
      <div
        className={Styled.ReviewWrapper({ isReviewsPage })}
        onClick={handleOpenReviewModal}>
        <div className={Styled.ReviewBlock}>
          <StarRating readOnly={true} ratingFromReview={rating} />
          <div itemProp="author" itemScope itemType="https://schema.org/Person">
            <Text font="paragraph.s.bold" tagProps={{ itemProp: 'name' }}>
              {user}
            </Text>
          </div>
          <meta itemProp="datePublished" content={getFormattedDate(date)} />
          <Text font="paragraph.s" color={ThemeColorValueImportance.LIGHTER}>
            {getFormattedDate(date)}
          </Text>
          <Text className={Styled.TextEllipsis} font="paragraph.s" tagProps={{ itemProp: 'reviewBody' }}>
            { review }
          </Text>
        </div>
        { isReviewsPage && answer && (
          <div className={Styled.ReviewBlock}>
            <Text font="paragraph.s" color={ThemeColorValueImportance.LIGHTER}>
              Ответ:
            </Text>
            <Text className={Styled.TextEllipsis} font="paragraph.s">
              {answer.text}
            </Text>
            <Text font="paragraph.s.bold">
              {answer.company}
            </Text>
            <Text font="paragraph.s" color={ThemeColorValueImportance.LIGHTER}>
              {getFormattedDate(answer.date)}
            </Text>
          </div>
        )}
        { !isReviewsPage && answer && (
        <Button
          className={Styled.ReadAnswerButton}
          size={ButtonSizes.XS}
          buttonType={ButtonTypes.TERTIARY}>
          Читать ответ
        </Button>
        )}
      </div>
      <ReviewModal
        rating={rating}
        user={user}
        date={getFormattedDate(date)}
        review={review}
        answer={answer}
        isShowModal={isOpenReviewModal}
        onClose={handleCloseReviewModal}
      />
    </div>
  );
};
export default memo(Review);
